import React from "react"

let url = ""

const SubmitReport = () => (
  <small className="text-center text-primary center pb-3">
    <i className="fa-solid fa-bug pr-1 text-warning"></i>
    <a
      href={`mailto:info@csglearn.com?subject=Website%20Issue%20Report&body=The%20is%20an%20issue%20with%20the%20webpage%20${url}%3A%0D%0A%0D%0AThe%20issue%20is%3A`}
    >
      Report an issue with this page
    </a>
  </small>
)

export default SubmitReport
